import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

const timelineEntries = [
  {
    date: '2025 - Present',
    title: 'Senior Associate - Quant Engineering',
    subtitle: 'Quoniam Asset Management, Frankfurt',
    description: 'Data Engineering, Investment Models, Data Platform',
  },
  {
    date: '2024 - 2025',
    title: 'Analytics Engineer',
    subtitle: 'Schibsted, Stockholm',
    description: 'ETL Pipelines, Data Modeling, AI Engineering',
  },
  {
    date: '2022 - 2024',
    title: 'Consultant Data Science',
    subtitle: 'statworx, Frankfurt',
    description: 'AI Education, Project Management, Stakeholder Communication',
  },
  {
    date: '2020 - 2022',
    title: 'Student Data Scientist',
    subtitle: 'Cyanite, Berlin',
    description: 'Deep Learning, Signal Processing, Natural Language Processing',
  },
  {
    date: '2018 - 2022',
    title: 'Student Research Associate',
    subtitle: 'Justus Liebig University, Gießen',
    description: 'Data Analysis, Statistics, Data Visualisation',
  },
];

const parallelTracks = [
  {
    period: '2023 - Present',
    title: 'Lead Audio AI Architect',
    subtitle: 'AudioApollo',
    description: 'Building the models, pipelines, and infrastructure for a music AI startup.',
  },
  {
    period: '2023 - Present',
    title: '(Music) AI Consultant',
    subtitle: 'Freelancing',
    description: 'Technical consulting, prototyping, and upskilling (music) companies on AI topics.',
  },
];

function Timeline() {
  return (
    <div id="history">
      <div className="items-container background-section">
        <h1>Background</h1>
        <VerticalTimeline>
          {timelineEntries.map((entry) => (
            <VerticalTimelineElement
              key={`${entry.date}-${entry.title}`}
              className="vertical-timeline-element--work"
              date={entry.date}
              icon={<FontAwesomeIcon icon={faBriefcase} />}
            >
              <h3 className="vertical-timeline-element-title">{entry.title}</h3>
              <h4 className="vertical-timeline-element-subtitle">{entry.subtitle}</h4>
              <p>
                {entry.description}
              </p>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
        <section className="parallel-tracks-section" aria-labelledby="entrepreneurship-freelancing-title">
          <h2 id="entrepreneurship-freelancing-title">Entrepreneurship and Freelancing</h2>
          <div className="parallel-tracks-grid">
            {parallelTracks.map((track, index) => (
              <article className="parallel-track-card" key={`${track.title}-${index}`}>
                <span className="parallel-track-period">{track.period}</span>
                <h3>{track.title}</h3>
                <h4>{track.subtitle}</h4>
                <p>{track.description}</p>
              </article>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

export default Timeline;